<h1>
  <a class="home-link" [routerLink]="['/' + getHomePath()]">
    <i class="fa fa-home" aria-hidden="true"></i>
    {{'Manage customers' | translate}}
  </a>
</h1>

<div class="overview-styling">
  <div *ngIf="getLoading()" class="ajax_loading_wrapper">
    <div class="ajax_loading"></div>
  </div>
  <div class="above-table-container" fxLayout>
    <div fxLayout="row" fxFlex>
      <form [formGroup]="getSearchForm()" fxLayout fxLayout="column" class="ng" fxFlex.xs="100" fxFill
            (ngSubmit)="submitRequest(); openMobileSearch()">

        <div fxLayout="row" fxLayoutGap="20px" fxLayout.xs="column">
          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100" fxLayoutAlign.xs=" stretch">
            <label class="control-label" fxFlex="35">
              {{'Status' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getActiveStates()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [(ngModel)]="selectedStatus"
                (change)="onSelectStatus($event)"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="status">>
              </ng-select>
            </div>
          </div>

          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100" fxLayoutAlign.xs=" stretch">
            <label class="control-label" fxFlex="35">
              {{'Target Group' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getTargetGroups()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [(ngModel)]="selectedTargetGroup"
                (change)="onSelectTGroup($event)"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="targetGroup">>
              </ng-select>
            </div>
          </div>

          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100">
            <label class="control-label" fxFlex="35">
              {{'Customer Confirmation' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getConfirmationStates()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [(ngModel)]="selectedConfirmed"
                (change)="onSelectConfirmation($event)"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="confirmation">>
              </ng-select>
            </div>
          </div>

          <div class="form-group" fxLayout="column" fxFlex="30" fxFlex.xs="100" fxLayoutAlign.xs=" stretch">
            <label class="control-label" fxFlex="35">
              {{'Country' | translate}}
            </label>
            <div class="input-container" fxLayout="column" fxFlex>
              <ng-select
                [items]="getCountryCode()"
                bindLabel="label"
                bindValue="value"
                [clearable]="false"
                [(ngModel)]="selectedCountry"
                (change)="onSelectCountryCode($event)"
                placeholder="{{'Please select...' | translate}}"
                notFoundText="{{'No results found' | translate}}"
                formControlName="countryCode">>
              </ng-select>
            </div>
          </div>
        </div>

        <div fxLayout="row" fxLayoutGap="66px">
          <div fxLayoutAlign="start" fxFlex="100">

            <button class="btn btn-secondary btn-search" type="submit">
              <i class="fa fa-search fa-lg" aria-hidden="true"></i>
            </button>

            <div class="search input-container" fxFlexFill>
              <input
                class="form-control form-control-border"
                type="text"
                formControlName="searchTerm"
                placeholder="{{'Search...' | translate}}">
              <i *ngIf="getSearchForm().controls.searchTerm.value && getSearchForm().controls.searchTerm.value.length"
                 class="fa fa-times fa-lg" aria-hidden="true"
                 (click)="clearInputField()"></i>
            </div>
          </div>

          <div fxLayout="end">
            <div class="above-table">
              <button (click)="goToNewCustomerPage()" class="btn btn-info add-btn" type="button">
                <i class="fa fa-plus fa-lg" aria-hidden="true"></i>
                <span fxHide.xs> {{'Create new customer' | translate}} </span>
              </button>
            </div>
          </div>
        </div>

      </form>
    </div>
  </div>

  <div class="form-container-content">
    <div fxHide.xs>
      <ul fxLayout="column" fxFlex>
        <li fxLayout fxFlex class="table-header">
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20"
               [ngClass]="{'sorting': sortingObj.sortCustomerNumberField.sorting == undefined, 'sorting_asc': sortingObj.sortCustomerNumberField.sorting == true, 'sorting_desc': sortingObj.sortCustomerNumberField.sorting == false}"
               (click)="sortTable(sortingObj.sortCustomerNumberField)">
            <h4>{{'Customer number' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20"
               [ngClass]="{'sorting': sortingObj.sortCompanyField.sorting == undefined, 'sorting_asc': sortingObj.sortCompanyField.sorting == true, 'sorting_desc': sortingObj.sortCompanyField.sorting == false}"
               (click)="sortTable(sortingObj.sortCompanyField)">
            <h4>{{'Company' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20"
               [ngClass]="{'sorting': sortingObj.sortCountryCodeField.sorting == undefined, 'sorting_asc': sortingObj.sortCountryCodeField.sorting == true, 'sorting_desc': sortingObj.sortCountryCodeField.sorting == false}"
               (click)="sortTable(sortingObj.sortCountryCodeField)">
            <h4>{{'Country' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20"
               [ngClass]="{'sorting': sortingObj.sortStatusField.sorting == undefined, 'sorting_asc': sortingObj.sortStatusField.sorting == true, 'sorting_desc': sortingObj.sortStatusField.sorting == false}"
               (click)="sortTable(sortingObj.sortStatusField)">
            <h4>{{'Status' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="30">
            <h4>{{'Target Group' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20"
               [ngClass]="{'sorting': sortingObj.sortConfirmedField.sorting == undefined, 'sorting_asc': sortingObj.sortConfirmedField.sorting == true, 'sorting_desc': sortingObj.sortConfirmedField.sorting == false}"
               (click)="sortTable(sortingObj.sortConfirmedField)">
            <h4>{{'Customer Confirmation' | translate}}</h4>
          </div>
          <div fxLayout fxLayoutAlign="end center" fxFlex="10"></div>
        </li>

        <li fxLayout class="table-items" *ngFor="let customer of getListOfCustomers()">
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20">
            <h5 class="table-item">{{customer.customerNumber}}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20">
            <h5 class="table-item">{{customer.customerName}}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20">
            <h5 class="table-item">{{customer.countryCode | translate}}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20">
            <h5 class="table-item">{{(true === customer.status ? 'active' : 'not-active') | translate }}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="30">
            <h5 class="table-item">{{customer.targetGroup | translate}}</h5>
          </div>
          <div fxLayout fxLayoutAlign="space-around center" fxFlex="20">
            <h5 class="table-item fas" [ngClass]="{'fa-check': customer.confirmed == true, 'fa-times': customer.confirmed == false }"></h5>
          </div>

          <div fxLayout fxLayoutAlign="end center" fxFlex="10" class="buttons-container">
            <button (click)="goToEditCustomer(customer)" class="btn btn-primary update-btn btn-icon" type="button">
              <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
            </button>
          </div>
        </li>
      </ul>
    </div>

    <!-- Appears if device is a mobile phone -->
    <div class="table-mobile-layout" fxLayout="column" fxHide.gt-xs>
      <div *ngFor="let customer of getListOfCustomers(); let i = index" fxLayout>
        <div fxLayout fxLayout="column" fxFlex="80">
          <div fxLayout fxFlex="25">
            <label fxLayoutAlign="start center" fxFlex="40">{{'Customer number' | translate}}: </label>
            <span>{{customer.number}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="40">{{'Company' | translate}}: </label>
            <span>{{customer.name}}</span>
          </div>
          <div fxLayout>
            <label fxFlex="40">{{'Status' | translate}}: </label>
            <span>{{(true === customer.active ? 'active' : 'not-active') | translate }}</span>
          </div>
          <div fxLayout>
            <label fxLayoutAlign="start center" fxFlex="40">{{'Target Group' | translate}}: </label>
            <span>{{customer.targetGroup | translate}}</span>
          </div>
          <div *ngIf="i < customer.length-1" class="divider"></div>
        </div>
        <div fxLayout="column" fxFlex="20" class="mobileButtonsContainer">
          <button (click)="goToEditCustomer(customer)" class="btn btn-primary update-btn btn-icon" type="button">
            <i class="fa fa-pencil fa-lg" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>

    <app-pagination
      [totalNumberOfItems]="getTotalNumberOfItems()"
      [pageSize]="getItemsPerPage()"
      (pageSizeChange)="onPageSizeChange($event)"
      (pageChange)="onPageChange($event)">
    </app-pagination>

  </div>
</div>
<div class="divider"></div>
